import { render, staticRenderFns } from "./ProjectSummaryUpdate.vue?vue&type=template&id=ec13eb86&"
import script from "./ProjectSummaryUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports